import { render } from "./ProductsFilters.vue?vue&type=template&id=35cdf48c&scoped=true"
import script from "./ProductsFilters.vue?vue&type=script&lang=js"
export * from "./ProductsFilters.vue?vue&type=script&lang=js"

import "./ProductsFilters.vue?vue&type=style&index=0&id=35cdf48c&lang=scss"
import "./ProductsFilters.vue?vue&type=style&index=1&id=35cdf48c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35cdf48c"]])

export default __exports__